(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* Dot indicators for the mobile product carousel.

     Progressive enhancement: the dots ship hidden and are only revealed once
     this runs, so a JS-less phone still gets a perfectly usable swipe strip.
     The scroll itself is pure CSS scroll-snap — this only mirrors position and
     lets a dot scroll to its card. */
  (function () {
    function init(track) {
      if (!track || track.dataset.carouselReady === '1') return;
      var dots = track.parentNode.querySelector('[data-carousel-dots]');
      if (!dots) return;
      track.dataset.carouselReady = '1';

      var buttons = [].slice.call(dots.querySelectorAll('[data-carousel-dot]'));
      var cards = [].slice.call(track.children);
      if (!buttons.length || cards.length < 2) return;
      dots.hidden = false;

      function reduced() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      }

      /* Nearest card to the track's current left edge wins. */
      function current() {
        var x = track.scrollLeft;
        var best = 0, bestD = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft - track.offsetLeft - x);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }

      function paint() {
        var a = current();
        for (var i = 0; i < buttons.length; i++) {
          var on = i === a;
          buttons[i].classList.toggle('is-active', on);
          buttons[i].setAttribute('aria-current', on ? 'true' : 'false');
        }
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { paint(); ticking = false; });
      }, { passive: true });

      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () {
          var card = cards[i];
          if (!card) return;
          track.scrollTo({
            left: card.offsetLeft - track.offsetLeft,
            behavior: reduced() ? 'auto' : 'smooth'
          });
        });
      });

      paint();
      window.addEventListener('resize', paint, { passive: true });
    }

    function initAll() {
      var tracks = document.querySelectorAll('[data-carousel]');
      for (var i = 0; i < tracks.length; i++) init(tracks[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero review strip on native scrolling.

     The browser owns the swipe (scroll-snap, momentum, overscroll), so touch
     feels like any other horizontal row. This script adds:
     - the loop: three identical passes, the page starts on the middle one, and
       when the row rests in an outer pass the position moves by exactly one
       pass width. Same pixels before and after, so nothing is seen;
     - auto-advance, one card every 3.5s;
     - mouse drag on desktop with a short fling, landing on a card.

     Auto-advance is built so that it cannot get stuck (it did, on iPhones):
     - the advance is our own requestAnimationFrame animation of scrollLeft
       with snap switched off while it runs, not scrollTo({behavior:'smooth'}).
       In a mandatory scroll-snap container iOS can cancel a programmatic smooth
       scroll and park the row back on the card it was on, so a timer that
       "fired" moved nothing;
     - one timer that always reschedules itself. A pause is a deadline (last
       real input + 4s) plus conditions read fresh on every tick, never a flag
       that waits for some later event to restart the loop;
     - "on screen" includes one screen below the fold, so it is already moving
       from first paint on a phone where the strip starts just under the fold.
     Off with prefers-reduced-motion, far off screen and in a hidden tab. */
  (function () {
    var AUTO_MS = 3500;       /* one card every 3.5s */
    var RESUME_MS = 4000;     /* after the last real interaction */
    var ANIM_MS = 520;
    var IDLE_MS = 140;
    var TOUCH_STALE_MS = 6000;
    var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    function init(root) {
      if (root.dataset.hrReady === '1') return;
      var slides = root.querySelectorAll('.hero-rev__slide');
      var n = slides.length / 3;
      if (!n || n % 1) return;
      root.dataset.hrReady = '1';

      var timer = 0, idleTimer = 0, anim = 0;
      var near = true, hovering = false, focused = false;
      var touching = false, lastTouchEvt = 0;
      var drag = null, suppressClick = false;
      var lastInput = -Infinity;      /* last real interaction (ms) */
      var inputUntil = 0;             /* scroll events before this follow a real input */
      var ownScrollUntil = 0;         /* scroll events before this are ours */
      var advances = 0;

      /* Scroll offset that parks slide i on the start edge. Sub-pixel, and
         independent of the current scroll position. */
      function pos(i) { return slides[i].getBoundingClientRect().left - slides[0].getBoundingClientRect().left; }
      function step() { return pos(1); }
      function passWidth() { return pos(n); }
      function index() {
        var s = step();
        return s > 0 ? Math.round(root.scrollLeft / s) : 0;
      }
      function setLeft(left) {
        ownScrollUntil = performance.now() + 150;
        root.scrollLeft = left;
      }

      /* Back into the middle pass. Only while nothing moves the row, and only
         from a resting snap position, so snap cannot pull it a card off. */
      var settleTries = 0;
      function normalize() {
        clearTimeout(idleTimer);
        if (touching || drag || anim) return;
        root.classList.remove('is-dragging');
        var i = index();
        if (Math.abs(root.scrollLeft - pos(i)) > 1.5 && settleTries++ < 25) {
          idleTimer = setTimeout(normalize, IDLE_MS);
          return;
        }
        settleTries = 0;
        if (i < n) setLeft(root.scrollLeft + passWidth());
        else if (i >= 2 * n) setLeft(root.scrollLeft - passWidth());
      }

      /* ---- the advance ---------------------------------------------- */
      function stopAnim() {
        if (!anim) return;
        cancelAnimationFrame(anim); anim = 0;
        root.style.scrollSnapType = '';
      }
      function animateTo(target) {
        stopAnim();
        var from = root.scrollLeft, dist = target - from, t0 = 0;
        if (Math.abs(dist) < 1) return;
        root.style.scrollSnapType = 'none';
        function frame(now) {
          if (!t0) t0 = now;
          var k = Math.min(1, (now - t0) / ANIM_MS);
          var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
          setLeft(from + dist * e);
          if (k < 1) { anim = requestAnimationFrame(frame); return; }
          anim = 0;
          setLeft(target);
          root.style.scrollSnapType = '';
          normalize();
        }
        anim = requestAnimationFrame(frame);
      }

      /* ---- the one timer ------------------------------------------- */
      function blocked() {
        if (touching && performance.now() - lastTouchEvt > TOUCH_STALE_MS) touching = false;
        return document.hidden || !near || hovering || focused || touching || !!drag;
      }
      function schedule(ms) {
        clearTimeout(timer);
        timer = setTimeout(tick, Math.max(50, ms));
      }
      var lastAdvance = performance.now();
      function tick() {
        timer = 0;
        if (mqReduce.matches) return;             /* the media query listener restarts it */
        var now = performance.now();
        if (blocked()) { schedule(500); return; }
        var due = Math.max(lastAdvance + AUTO_MS, lastInput + RESUME_MS);
        if (now < due - 16) { schedule(due - now); return; }
        normalize();
        animateTo(pos(Math.min(3 * n - 1, index() + 1)));
        lastAdvance = now;
        advances++;
        schedule(AUTO_MS);
      }
      function interacted() {
        lastInput = performance.now();
        inputUntil = lastInput + 1000;
        stopAnim();
      }

      root.addEventListener('scroll', function () {
        var now = performance.now();
        clearTimeout(idleTimer);
        idleTimer = setTimeout(normalize, IDLE_MS);
        /* Momentum after a swipe or wheel counts as the shopper's; scroll that
           comes from layout or from us does not, so it cannot hold the row. */
        if (now > ownScrollUntil && (touching || drag || now < inputUntil)) {
          lastInput = now; inputUntil = now + 1000;
        }
      }, { passive: true });
      root.addEventListener('scrollend', function () { normalize(); });

      root.addEventListener('touchstart', function () {
        touching = true; lastTouchEvt = performance.now(); interacted();
      }, { passive: true });
      root.addEventListener('touchmove', function () { lastTouchEvt = performance.now(); }, { passive: true });
      function touchEnd() {
        touching = false; interacted();
        clearTimeout(idleTimer);
        idleTimer = setTimeout(normalize, IDLE_MS);
      }
      root.addEventListener('touchend', touchEnd, { passive: true });
      root.addEventListener('touchcancel', touchEnd, { passive: true });
      root.addEventListener('wheel', interacted, { passive: true });
      root.addEventListener('keydown', interacted);

      /* Hover only counts where there is a real hovering pointer. */
      var canHover = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true;
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && canHover) hovering = true; });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && hovering) { hovering = false; interacted(); } });
      /* Keyboard focus only: a tap or click also focuses the row, and pausing on
         that would stop it for as long as focus stayed there. */
      root.addEventListener('focusin', function (e) {
        var keyboard = true;
        try { keyboard = e.target.matches(':focus-visible'); } catch (err) {}
        if (keyboard) focused = true;
      });
      root.addEventListener('focusout', function (e) {
        if (e.relatedTarget && root.contains(e.relatedTarget)) return;
        if (focused) { focused = false; interacted(); }
      });

      /* Mouse drag (desktop). Snap is off while the row follows the pointer and
         comes back once it has landed on a card. */
      root.addEventListener('pointerdown', function (e) {
        interacted();
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        e.preventDefault();
        drag = { id: e.pointerId, x: e.clientX, left: root.scrollLeft, lastX: e.clientX, lastT: performance.now(), v: 0, active: false };
      });
      root.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!drag.active) {
          if (Math.abs(dx) < 5) return;
          drag.active = true;
          root.classList.add('is-dragging');
          try { root.setPointerCapture(drag.id); } catch (err) {}
        }
        var now = performance.now();
        drag.v = (e.clientX - drag.lastX) / Math.max(1, now - drag.lastT);
        drag.lastX = e.clientX; drag.lastT = now;
        root.scrollLeft = drag.left - dx;
      });
      function dragEnd(e) {
        if (!drag) { if (e && e.pointerType !== 'mouse') interacted(); return; }
        if (e && e.pointerId !== drag.id) return;
        var d = drag; drag = null;
        interacted();
        if (!d.active) return;
        suppressClick = true;
        var fling = performance.now() - d.lastT < 80 ? Math.max(-1.5, Math.min(1.5, d.v)) * 260 : 0;
        var i = Math.max(0, Math.min(3 * n - 1, Math.round((root.scrollLeft - fling) / step())));
        animateTo(pos(i));
      }
      root.addEventListener('pointerup', dragEnd);
      root.addEventListener('pointercancel', dragEnd);
      root.addEventListener('click', function (e) {
        if (!suppressClick) return;
        suppressClick = false;
        e.preventDefault(); e.stopPropagation();
      }, true);

      /* Keep the same card on the start edge through rotation and resizes. */
      var lastIndex = index();
      root.addEventListener('scroll', function () { if (!anim) lastIndex = index(); }, { passive: true });
      if ('ResizeObserver' in window) {
        var firstRO = true;
        new ResizeObserver(function () {
          if (firstRO) { firstRO = false; return; }
          stopAnim();
          setLeft(pos(Math.max(0, Math.min(3 * n - 1, lastIndex))));
        }).observe(root);
      }

      /* Near the screen = in the viewport or within one screen below it. The
         newest entry wins: a batched callback can carry a stale one first. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          near = entries[entries.length - 1].isIntersecting;
        }, { rootMargin: '0px 0px 100% 0px' }).observe(root);
      }
      if (mqReduce.addEventListener) {
        mqReduce.addEventListener('change', function () { if (mqReduce.matches) stopAnim(); else schedule(AUTO_MS); });
      }

      /* If the inline start script did not run (theme editor re-render), park on
         the middle pass now. */
      if (index() < n) setLeft(pos(n));

      /* Read-only handle for QA probes. */
      root.__heroRev = {
        n: n, index: index, pos: pos, passWidth: passWidth,
        state: function () {
          return { timer: !!timer, near: near, visible: near, hovering: hovering, focused: focused, touching: touching,
            dragging: !!drag, animating: !!anim, reduce: mqReduce.matches, hidden: document.hidden, advances: advances,
            blocked: blocked() };
        }
      };
      if (!mqReduce.matches) schedule(AUTO_MS);
    }

    function initAll() {
      var list = document.querySelectorAll('[data-hero-rev]');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
